/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ds_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why does my drive show less space than advertised?`)
};

const es_ds_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué mi unidad muestra menos espacio del anunciado?`)
};

const de_ds_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum zeigt mein Laufwerk weniger Speicherplatz an als beworben?`)
};

const nl_ds_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom toont mijn schijf minder ruimte dan aangekondigd?`)
};

const fr_ds_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi mon lecteur affiche-t-il moins d'espace que prévu ?`)
};

const it_ds_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché la mia unità di archiviazione mostra meno spazio di quanto pubblicizzato?`)
};

const pt_br2_ds_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que meu drive mostra menos espaço do que anunciado?`)
};

const pt_ds_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que a minha unidade mostra menos espaço do que anunciado?`)
};

const ja_ds_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドライブが広告されているより少ないスペースを表示するのはなぜですか?`)
};

const zh_ds_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么我的硬盘显示的空间比标称的少?`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ds_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ds_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ds_faq4_q", locale)
	if (locale === "en") return en_ds_faq4_q(inputs)
	if (locale === "es") return es_ds_faq4_q(inputs)
	if (locale === "de") return de_ds_faq4_q(inputs)
	if (locale === "nl") return nl_ds_faq4_q(inputs)
	if (locale === "fr") return fr_ds_faq4_q(inputs)
	if (locale === "it") return it_ds_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_ds_faq4_q(inputs)
	if (locale === "pt") return pt_ds_faq4_q(inputs)
	if (locale === "ja") return ja_ds_faq4_q(inputs)
	return zh_ds_faq4_q(inputs)
};